import React from 'react';
import PropTypes from 'prop-types';
import InfoViewComponent from './../Components/InfoViewComponent.jsx';
import { keys } from 'lodash';
import { params as paramHelpers } from './../helpers';
import { customPrioritySort } from '../helpers/utils';

export default class JobParamsInfoComponent extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    jobId: PropTypes.number,
    paramsByIds: PropTypes.object,
    displayAllMetrics: PropTypes.bool
  };

  sortParamsByKey(parameters) {
    const sortedKeys = customPrioritySort(
      keys(paramHelpers.paramsOrder),
      keys(parameters)
    );
    const toReturn = {};
    for (const key in sortedKeys) {
      toReturn[sortedKeys[key]] = parameters[sortedKeys[key]];
    }
    return toReturn;
  }

  render() {
    const {
      title,
      jobId,
      paramsByIds,
      displayAllMetrics
    } = this.props;
    let paramsView = null;

    const paramsTitle = title.indexOf('No Build Tag') === -1 ?
      'Params: ' + title : title;
    const parameters = paramsByIds ? paramsByIds[jobId] : {};
    const displayParams = paramHelpers.cleanParams(
      parameters,
      paramHelpers.regressionPageDisplayList
    );
    if (parameters) {
      paramsView =
        <InfoViewComponent
          title={paramsTitle}
          items={this.sortParamsByKey(displayParams)}
          showWide={displayAllMetrics}
        />;
    }

    return (
      <div>
        {paramsView}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// src/Components/JobParamsInfoComponent.jsx